import React from 'react'

function About() {
  return (
    <div>
        <div className='mt-60'>
            <p className='text-white'>
            <h2 className='text-center text-2xl'><b>Welcome to Battle Bots</b></h2>
Battle Bots is an exciting online platform where strategy meets technology. Our platform allows users to assemble a team of powerful bots, each with unique abilities and characteristics. Whether you're a seasoned strategist or just looking for a bit of fun, Battle Bots offers an immersive experience that lets you build, customize, and command your very own bot army.

<h3 className='text-center text-2xl'><b>Our Mission</b></h3>
At Battle Bots, our mission is to create an engaging and dynamic environment where users can explore the endless possibilities of bot customization and strategy. We believe in empowering our users to unleash their creativity by offering a wide range of bots and features that cater to different playstyles. Our goal is to foster a community of bot enthusiasts who are passionate about innovation, competition, and collaboration.

<h3 className='text-center text-2xl'><b>What We Offer</b></h3>
1. Diverse Bot Collection
Explore a vast array of bots, each with distinct attributes, roles, and designs. Whether you're looking for a frontline assault bot, a supportive medic, or a strategic defender, you'll find the perfect addition to your team.
2. Team Building
Create and manage your own bot army by selecting from our diverse bot classes. Carefully choose your bots to form a balanced and powerful team, ready to take on any challenge.
3. In-Depth Customization
Dive deep into the details with our bot customization options. Tailor your bots to fit your strategy, from their appearance to their abilities, and prepare them for battle.
4. Dynamic Battles
Put your bots to the test in dynamic and strategic battles. Use your wits and the unique abilities of your bots to outmaneuver your opponents and claim victory.
5. Community and Collaboration
Join a vibrant community of bot enthusiasts. Share your strategies, collaborate with others, and participate in events to showcase your bot-building skills.
<h3 className='text-center text-2xl'><b>Our Vision</b></h3>
We envision a world where the thrill of strategy and the excitement of technology combine to create a unique gaming experience. Battle Bots is more than just a game; it's a platform for innovation, learning, and creativity. We aim to continuously evolve and expand our platform, offering new features, bots, and challenges to keep the experience fresh and engaging.

        </p>
        </div>
        
    </div>
  )
}

export default About